"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SharedBasesController", {
    enumerable: true,
    get: function() {
        return SharedBasesController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _sharedbasesservice = require("~/services/shared-bases.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let SharedBasesController = class SharedBasesController {
    async createSharedBaseLink(context, req, body, baseId) {
        const sharedBase = await this.sharedBasesService.createSharedBaseLink(context, {
            baseId: baseId,
            roles: body == null ? void 0 : body.roles,
            password: body == null ? void 0 : body.password,
            siteUrl: req.ncSiteUrl,
            req
        });
        return sharedBase;
    }
    async updateSharedBaseLink(context, req, body, baseId) {
        const sharedBase = await this.sharedBasesService.updateSharedBaseLink(context, {
            baseId: baseId,
            roles: body == null ? void 0 : body.roles,
            password: body == null ? void 0 : body.password,
            siteUrl: req.ncSiteUrl,
            req,
            custom_url_path: body.custom_url_path
        });
        return sharedBase;
    }
    async disableSharedBaseLink(context, baseId, req) {
        const sharedBase = await this.sharedBasesService.disableSharedBaseLink(context, {
            baseId,
            req
        });
        return sharedBase;
    }
    async getSharedBaseLink(context, req, baseId) {
        const sharedBase = await this.sharedBasesService.getSharedBaseLink(context, {
            baseId: baseId,
            siteUrl: req.ncSiteUrl
        });
        return sharedBase;
    }
    constructor(sharedBasesService){
        this.sharedBasesService = sharedBasesService;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/projects/:baseId/shared',
        '/api/v2/meta/bases/:baseId/shared'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('createSharedBaseLink'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Param)('baseId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        Object,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], SharedBasesController.prototype, "createSharedBaseLink", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/projects/:baseId/shared',
        '/api/v2/meta/bases/:baseId/shared'
    ]),
    (0, _extractidsmiddleware.Acl)('updateSharedBaseLink'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Param)('baseId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        Object,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], SharedBasesController.prototype, "updateSharedBaseLink", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/projects/:baseId/shared',
        '/api/v2/meta/bases/:baseId/shared'
    ]),
    (0, _extractidsmiddleware.Acl)('disableSharedBaseLink'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], SharedBasesController.prototype, "disableSharedBaseLink", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/shared',
        '/api/v2/meta/bases/:baseId/shared'
    ]),
    (0, _extractidsmiddleware.Acl)('getSharedBaseLink'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], SharedBasesController.prototype, "getSharedBaseLink", null);
SharedBasesController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _sharedbasesservice.SharedBasesService === "undefined" ? Object : _sharedbasesservice.SharedBasesService
    ])
], SharedBasesController);
